/**
 * Generated Metadata
 *
 * DO NOT EDIT - Generated by scripts/generate.ts
 * Run `npm run generate` to regenerate.
 */

import type { BehaviorCategory, BehaviorTier } from '../schemas/types';
import type { BehaviorName } from './types';

/**
 * All behavior names.
 */
export const ALL_BEHAVIOR_NAMES: BehaviorName[] = [
  "Draggable",
  "Sortable",
  "Resizable",
  "Removable",
  "Toggleable",
  "Clipboard",
  "AutoDismiss",
  "ClickOutside",
  "FocusTrap",
  "ScrollReveal",
  "Tabs"
];

/**
 * Behaviors grouped by category.
 */
export const BEHAVIORS_BY_CATEGORY: Record<BehaviorCategory, BehaviorName[]> = {
  "ui": [
    "Draggable",
    "Sortable",
    "Resizable",
    "Clipboard",
    "AutoDismiss",
    "ClickOutside",
    "FocusTrap",
    "Tabs"
  ],
  "data": [
    "Removable"
  ],
  "animation": [],
  "form": [
    "Toggleable"
  ],
  "layout": [
    "ScrollReveal"
  ]
};

/**
 * Behaviors grouped by tier.
 */
export const BEHAVIORS_BY_TIER: Record<BehaviorTier, BehaviorName[]> = {
  "core": [
    "Draggable",
    "Toggleable",
    "Clipboard",
    "AutoDismiss",
    "ClickOutside",
    "FocusTrap",
    "Tabs"
  ],
  "common": [
    "Sortable",
    "Removable",
    "ScrollReveal"
  ],
  "optional": [
    "Resizable"
  ]
};

/**
 * Category for each behavior.
 */
export const BEHAVIOR_CATEGORIES: Record<BehaviorName, BehaviorCategory> = {
  "Draggable": "ui",
  "Sortable": "ui",
  "Resizable": "ui",
  "Removable": "data",
  "Toggleable": "form",
  "Clipboard": "ui",
  "AutoDismiss": "ui",
  "ClickOutside": "ui",
  "FocusTrap": "ui",
  "ScrollReveal": "layout",
  "Tabs": "ui"
};

/**
 * Tier for each behavior.
 */
export const BEHAVIOR_TIERS: Record<BehaviorName, BehaviorTier> = {
  "Draggable": "core",
  "Sortable": "common",
  "Resizable": "optional",
  "Removable": "common",
  "Toggleable": "core",
  "Clipboard": "core",
  "AutoDismiss": "core",
  "ClickOutside": "core",
  "FocusTrap": "core",
  "ScrollReveal": "common",
  "Tabs": "core"
};
